import React from 'react';
import { useTranslation } from 'react-i18next';

import { AreaOfExpertiseDetails } from '../../../../models/ProviderDetails';
import { SmartChoiceBreakDownWidgetHeader } from '../../../SmartChoiceBreakDownDrawer/SmartChoiceBreakDownWidgetHeader';
import { AoeDescriptionContent } from './AoeDescriptionContent';

type Props = {
  areaOfExpertiseDetails?: AreaOfExpertiseDetails[];
  handleBackButton: () => void;
  handleCrossButton: () => void;
};

export const AoeWidgetPage = ({
  areaOfExpertiseDetails,
  handleBackButton,
  handleCrossButton,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div data-testid="aoe-widget-page">
      <SmartChoiceBreakDownWidgetHeader
        handleBackButton={handleBackButton}
        handleCrossButton={handleCrossButton}
        headingOffset={3}
        headingTitle={t(
          'PROVIDER_DETAILS.ABOUT_TAB.DETAILS_SECTION.AREAS_OF_EXPERTISE'
        )}
      />
      <div style={{ padding: '16px' }}>
        <AoeDescriptionContent
          areaOfExpertiseDetails={areaOfExpertiseDetails}
        />
      </div>
    </div>
  );
};
